import { Box, Button } from "@mui/material";
import { Icon } from "components/Icons";
import React, { useEffect, useState } from "react";
import { _project } from 'state/store.projects'
import { getProjectData } from 'state/jotai.projectDataHooks'
import { get, getFocus, useGet } from "state/jotai";
import { active_project } from "state/store.global";
import { _bootstrap } from "state/store.bootstrap";
import { useActiveUnit } from "./hooks";

function Downloads() {
  const downloads = getFocus(_project, 'downloads')
  const { pin, pid } = useGet(active_project) 
  const unit = useActiveUnit();
  const buttonsLabel  = getFocus(_project, 'buttonsLabel')?.[pin]?.[pid] ?? []
  const sitename  = useGet(_bootstrap).sitename;

  const [filteredData, setFilteredData] = useState([]);


  useEffect(()=> {
    const flag = Object.keys(unit || {}).length && Object.keys(downloads || {}).length
        if(flag) {
          const dnd = downloads.filter( d => {
            return d?.[unit?.data?.ProjectID]
          })

          setFilteredData(dnd?.[0]?.[unit?.data?.ProjectID])
        }
     }, [downloads, unit?.data?.ProjectID])

  if (downloads.length === 0) {
    return null; // If downloads array is empty
  }

   // filtering out duplicate downloads
   const filterData = filteredData?.filter((item, index, self) => index === self.findIndex((t) => t.url === item.url)) || []
//  console.log(filterData,"ksks");
 if(filterData?.length == 0){
  return null
 }
  return (
    <Box
      sx={{
        mt: "45px",
      }}
    >
      <Box sx={{ fontWeight: 700, mb: "18px" }}>{ buttonsLabel?.filter( btn => btn.UILabelProperty === 'HentMateriale')[0]?.Label }</Box>
      {filterData?.map((item, i) => {
         if(item.property === 'Prisliste') return <></>
        return (
          <Box key={i}>
            <Button
              variant="text"
              href={item?.url}
              target="_blank"
              startIcon={<Icon icon="download" />}
            >
              <span>{ ["Prisliste", "Brochure"].includes(item?.property) ? `${buttonsLabel?.filter( btn => btn.UILabelProperty === item?.property)[0]?.Label} - ${sitename}` : item?.property }</span>
            </Button>
          </Box>
        );
      })}
    </Box>
  );
}

export default Downloads;
